import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, MutationIntentProjectDeleteArgs } from "types/generated";

export const DELETE_INTENT_PROJECT: TypedDocumentNode<
  { intentProjectDelete: IntentProject | null },
  MutationIntentProjectDeleteArgs
> = gql`
  mutation DeleteIntentProject($id: ID!, $keepResources: Boolean) {
    intentProjectDelete(id: $id, keepResources: $keepResources) {
      id
      name
    }
  }
`;
